// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_6_e","content":"styles_content__bNxq0"};